import React, { useState, useCallback } from "react";
import { connect } from "react-redux";
import routes from "../../../assets/apiRoutes.json"
import axios from "axios";
import { GridLayout } from "../../../common/GridLayout";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager";
import { Toolbar as MainToolbar, Item as MainItem } from 'devextreme-react/toolbar';
import { Localization } from "../../../common/Localization";

import DataGrid, {
  Column,
  Paging,
  Selection,
  Toolbar,
  Item,
  FilterRow,
  FilterPanel,
  FilterBuilderPopup,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnFixing,
  Sorting,
  Export,
  Pager,
  HeaderFilter,
  StateStoring,
  Lookup,
  GroupPanel,
  Grouping
} from 'devextreme-react/data-grid';

import { alert } from 'devextreme/ui/dialog';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import {
  OrchardTypeArr,
  ElevationArr,
  SpeciesArr,
  BlockCycleArr,
  StimCycleArr,
  StimStatusArr,
  BreedingAreaArr,
  PositionArr
} from '../const/StaticData';
const filterBuilderPopupPosition = {
  of: window,
  at: 'top',
  my: 'top',
  offset: { y: 10 },
};

const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
let accessToken = '';
const gridKey = "ed5e8449-ddb4-42a7-b72b-2eab3425da65";
const dataGrid = React.createRef();
const customers = [{
  ID: 1,
  CompanyName: 'Premier Buy',
  Address: '7601 Penn Avenue South',
  City: 'Richfield',
  State: 'Minnesota',
  Zipcode: 55423,
  Phone: '(612) 291-1000',
  Fax: '(612) 291-2001',
  Website: 'http =//www.nowebsitepremierbuy.com',
}, {
  ID: 2,
  CompanyName: 'ElectrixMax',
  Address: '263 Shuman Blvd',
  City: 'Naperville',
  State: 'Illinois',
  Zipcode: 60563,
  Phone: '(630) 438-7800',
  Fax: '(630) 438-7801',
  Website: 'http =//www.nowebsiteelectrixmax.com',
}, {
  ID: 3,
  CompanyName: 'Video Emporium',
  Address: '1201 Elm Street',
  City: 'Dallas',
  State: 'Texas',
  Zipcode: 75270,
  Phone: '(214) 854-3000',
  Fax: '(214) 854-3001',
  Website: 'http =//www.nowebsitevideoemporium.com',
}, {
  ID: 4,
  CompanyName: 'Screen Shop',
  Address: '1000 Lowes Blvd',
  City: 'Mooresville',
  State: 'North Carolina',
  Zipcode: 28117,
  Phone: '(800) 445-6937',
  Fax: '(800) 445-6938',
  Website: 'http =//www.nowebsitescreenshop.com',
}, {
  ID: 5,
  CompanyName: 'Braeburn',
  Address: '1 Infinite Loop',
  City: 'Cupertino',
  State: 'California',
  Zipcode: 95014,
  Phone: '(408) 996-1010',
  Fax: '(408) 996-1012',
  Website: 'http =//www.nowebsitebraeburn.com',
}, {
  ID: 6,
  CompanyName: 'PriceCo',
  Address: '30 Hunter Lane',
  City: 'Camp Hill',
  State: 'Pennsylvania',
  Zipcode: 17011,
  Phone: '(717) 761-2633',
  Fax: '(717) 761-2334',
  Website: 'http =//www.nowebsitepriceco.com',
}, {
  ID: 7,
  CompanyName: 'Ultimate Gadget',
  Address: '1557 Watson Blvd',
  City: 'Warner Robbins',
  State: 'Georgia',
  Zipcode: 31093,
  Phone: '(995) 623-6785',
  Fax: '(995) 623-6786',
  Website: 'http =//www.nowebsiteultimategadget.com',
}, {
  ID: 8,
  CompanyName: 'EZ Stop',
  Address: '618 Michillinda Ave.',
  City: 'Arcadia',
  State: 'California',
  Zipcode: 91007,
  Phone: '(626) 265-8632',
  Fax: '(626) 265-8633',
  Website: 'http =//www.nowebsiteezstop.com',
}, {
  ID: 9,
  CompanyName: 'Clicker',
  Address: '1100 W. Artesia Blvd.',
  City: 'Compton',
  State: 'California',
  Zipcode: 90220,
  Phone: '(310) 884-9000',
  Fax: '(310) 884-9001',
  Website: 'http =//www.nowebsiteclicker.com',
}, {
  ID: 10,
  CompanyName: 'Store of America',
  Address: '2401 Utah Ave. South',
  City: 'Seattle',
  State: 'Washington',
  Zipcode: 98134,
  Phone: '(206) 447-1575',
  Fax: '(206) 447-1576',
  Website: 'http =//www.nowebsiteamerica.com',
}, {
  ID: 11,
  CompanyName: 'Zone Toys',
  Address: '1945 S Cienega Boulevard',
  City: 'Los Angeles',
  State: 'California',
  Zipcode: 90034,
  Phone: '(310) 237-5642',
  Fax: '(310) 237-5643',
  Website: 'http =//www.nowebsitezonetoys.com',
}, {
  ID: 12,
  CompanyName: 'ACME',
  Address: '2525 E El Segundo Blvd',
  City: 'El Segundo',
  State: 'California',
  Zipcode: 90245,
  Phone: '(310) 536-0611',
  Fax: '(310) 536-0612',
  Website: 'http =//www.nowebsiteacme.com',
}, {
  ID: 13,
  CompanyName: 'Super Mart of the West',
  Address: '702 SW 8th Street',
  City: 'Bentonville',
  State: 'Arkansas',
  Zipcode: 72716,
  Phone: '(800) 555-2797',
  Fax: '(800) 555-2171',
  Website: 'http://www.nowebsitesupermart.com',
}, {
  ID: 14,
  CompanyName: 'Electronics Depot',
  Address: '2455 Paces Ferry Road NW',
  City: 'Atlanta',
  State: 'Georgia',
  Zipcode: 30339,
  Phone: '(800) 595-3232',
  Fax: '(800) 595-3231',
  Website: 'http =//www.nowebsitedepot.com',
}, {
  ID: 15,
  CompanyName: 'K&S Music',
  Address: '1000 Nicllet Mall',
  City: 'Minneapolis',
  State: 'Minnesota',
  Zipcode: 55403,
  Phone: '(612) 304-6073',
  Fax: '(612) 304-6074',
  Website: 'http =//www.nowebsitemusic.com',
}, {
  ID: 16,
  CompanyName: "Tom's Club",
  Address: '999 Lake Drive',
  City: 'Issaquah',
  State: 'Washington',
  Zipcode: 98027,
  Phone: '(800) 955-2292',
  Fax: '(800) 955-2293',
  Website: 'http =//www.nowebsitetomsclub.com',
}, {
  ID: 17,
  CompanyName: 'E-Mart',
  Address: '3333 Beverly Rd',
  City: 'Hoffman Estates',
  State: 'Illinois',
  Zipcode: 60179,
  Phone: '(847) 286-2500',
  Fax: '(847) 286-2501',
  Website: 'http =//www.nowebsiteemart.com',
}, {
  ID: 18,
  CompanyName: 'Walters',
  Address: '200 Wilmot Rd',
  City: 'Deerfield',
  State: 'Illinois',
  Zipcode: 60015,
  Phone: '(847) 940-2500',
  Fax: '(847) 940-2501',
  Website: 'http =//www.nowebsitewalters.com',
}, {
  ID: 19,
  CompanyName: 'StereoShack',
  Address: '400 Commerce S',
  City: 'Fort Worth',
  State: 'Texas',
  Zipcode: 76102,
  Phone: '(817) 820-0741',
  Fax: '(817) 820-0742',
  Website: 'http =//www.nowebsiteshack.com',
}, {
  ID: 20,
  CompanyName: 'Circuit Town',
  Address: '2200 Kensington Court',
  City: 'Oak Brook',
  State: 'Illinois',
  Zipcode: 60523,
  Phone: '(800) 955-2929',
  Fax: '(800) 955-9392',
  Website: 'http =//www.nowebsitecircuittown.com',
}];

class InventoryReports extends React.Component {

  constructor(props) {
    super(props);

    accessToken = props.oidc.user.access_token;
    this.state = {
      currentLayout: "Default"
    };
    this.onContentReady = this.onContentReady.bind(this);
    this.userStatusDataSource = createStore({
      key: "code",
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.RametCodes.GetUserStatusCodes}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          access_token: accessToken
        };
      }
    });

    this.dataSource = createStore({
      key: 'rowid',
      loadUrl: `${window._env_.REACT_APP_APIS}/${routes.InventoryReports.GetData}`,
      onBeforeSend: function (method, ajaxOptions) {
        ajaxOptions.headers = {
          Authorization: `Bearer ${accessToken}`
        };
      }
    });
  }

  render() {
    return (
      <div className="h-100" style={{ overflowY: 'hidden' }}>
        <div className="title">
          <h6
            style={{
              color: window._env_.Color2
            }}
          >
            Inventory Reports
          </h6>
        </div>
        <DataGrid
          ref={dataGrid}
onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }} id="gridContainer"

          onContentReady={this.onContentReady}
          showBorders={true}
          className="ATConfigurationGridStyle"
          rowAlternationEnabled={true}
          allowColumnResizing={true}
          allowColumnReordering={true}
          columnAutoWidth={true}
        >
          <Grouping autoExpandAll={false} />
          <GroupPanel visible={true} />
          <Export enabled={true} allowExportSelectedData={true} text="Export" />
          <Selection mode="multiple" />
          <Paging
            enabled={true}
          />
          <Pager
            visible={true}
            showPageSizeSelector={true}
            allowedPageSizes={allowedPageSizes}
            showNavigationButtons={true}
            showInfo={true}
          />
          <FilterRow visible={true} />
          <FilterPanel visible={true} />
          <FilterBuilderPopup position={filterBuilderPopupPosition} />
          <ColumnChooser
            enabled={true}
            title="Choose Column"
            width={290}
            height={290}
            sortOrder="asc"
          >
            <ColumnChooserSearch
              enabled={true}
              editorOptions={{ placeholder: 'Search column' }} />
          </ColumnChooser>
          <HeaderFilter visible={true} />
          <ColumnFixing enabled={true} />,
          <Sorting mode="multiple" />
          <StateStoring
            enabled={true}
            type="custom"
            customLoad={this.loadState}
            storageKey={gridKey}
            customSave={this.saveState}
          />
          <Column dataField="orchardcode" caption="Orchard Code" />
          <Column dataField="orchardname" caption="Orchard Name" visible={false} />
          <Column dataField="orchardstatus" caption="Orchard Status" visible={false}>
            <Lookup
              dataSource={this.statusArr}
              displayExpr="name"
              valueExpr="value"
              defaultValue={"A"} />
          </Column>
          <Column dataField="orchardcomment" caption="Orchard Comment" visible={false} />
          <Column dataField="blockcode" caption="Block Code" />
          <Column dataField="blockdescription" caption="Block Description" visible={false} />
          <Column dataField="blockstatus" caption="Block Status" visible={false}>
            <Lookup
              dataSource={this.statusArr}
              displayExpr="name"
              valueExpr="value"
              defaultValue={"A"} />
          </Column>
          <Column dataField="blockcomment" caption="Block Comment" visible={false} />
          <Column dataField="locationcode" caption="Location Code" />
          <Column dataField="locationdescription" caption="Location Description" visible={false} />
          <Column dataField="locationstatus" caption="Location Status" visible={false}>
            <Lookup
              dataSource={this.locationStatusArr}
              displayExpr="name"
              valueExpr="value"
              defaultValue={"A"} />
          </Column>
          <Column dataField="positiony" caption="Column" dataType="number" />
          <Column dataField="positionx" caption="Row" dataType="number" />
          <Column dataField="locationcomment" caption="Location Comment" visible={false} />
          <Column dataField="locationassets" caption="Location Assets" visible={false} />
          <Column dataField="assetcode" caption="Ramet Code" />
          <Column dataField="assetdescription" caption="Ramet Description" visible={false} />
          <Column dataField="orchardtype" caption="Orchard Type" visible={false}>
            <Lookup
              dataSource={OrchardTypeArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="elevation" caption="Elevation" visible={false}>
            <Lookup
              dataSource={ElevationArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="species" caption="Species" visible={false}>
            <Lookup
              dataSource={SpeciesArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="blockcycle" caption="Block Cycle" visible={false}>
            <Lookup
              dataSource={BlockCycleArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="stimcycle" caption="Stim Cycle" visible={false}>
            <Lookup
              dataSource={StimCycleArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="stimstatus" caption="Stim Status" visible={false}>
            <Lookup
              dataSource={StimStatusArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="breedingarea" caption="Breeding Area" visible={false}>
            <Lookup
              dataSource={BreedingAreaArr}
              displayExpr="name"
              valueExpr="value" />
          </Column>
          <Column dataField="rootstock" caption="Root Stock" visible={false}>
          </Column>
          <Column dataField="parent" caption="Parent" visible={false}>
          </Column>
          <Column dataField="graftdate" dataType="date" caption="Graft Date"></Column>
          <Column dataField="plantdate" dataType="date" caption="Plant Date"></Column>
          <Column dataField="userstatus" caption="Ramet Status" visible={false}>
            <Lookup
              dataSource={this.userStatusDataSource}
              displayExpr="description1"
              valueExpr="code" />
          </Column>
          <Toolbar>
            <Item name="groupPanel" />
            <Item location="after">
              <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={this.setCurrentLayout} />
            </Item>
            <Item name="exportButton" />
            <Item name="columnChooserButton" />
          </Toolbar>
        </DataGrid>
      </div>
    );
  }

  setCurrentLayout = (value) => {
    this.setState({ currentLayout: value });
  }

  loadState = () => {
    return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, this.state.currentLayout);
  }

  saveState = (state) => {
    GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, this.state.currentLayout);
  }

  onContentReady(e) {
    if (!e.component._hasLoaded) {
      e.component._hasLoaded = true;
      e.component.option("dataSource", this.dataSource);
    }
  }

}

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}

export default connect(mapStateToProps)(InventoryReports);
